import * as React from 'react';

const FlutterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height="29" viewBox="0 0 23 29" width="23" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clipPath="url(#clip0_716_824)">
            <path d="M14.1274 0.0568848L0.201172 13.9832L4.51162 18.2936L22.7484 0.0568848H14.1274Z" fill="white" />
            <path
                d="M14.0303 12.8994L6.57373 20.3559L10.9004 24.7472L15.2029 20.4447L22.7483 12.8994H14.0303Z"
                fill="white"
            />
            <path d="M10.9004 24.7473L14.1757 28.0227H22.7482L15.2028 20.4448L10.9004 24.7473Z" fill="white" />
            <path d="M6.52539 20.4044L10.8359 16.0939L15.203 20.4448L10.9006 24.7473L6.52539 20.4044Z" fill="#CCCCCC" />
            <path
                d="M10.9004 24.7473L14.483 23.5585L14.8389 20.8087L10.9004 24.7473Z"
                fill="url(#paint0_linear_716_824)"
                fillOpacity="0.8"
            />
        </g>
        <defs>
            <linearGradient
                gradientUnits="userSpaceOnUse"
                id="paint0_linear_716_824"
                x1="26.4641"
                x2="309.82"
                y1="127.122"
                y2="229.23"
            >
                <stop stopColor="white" />
            </linearGradient>
            <clipPath id="clip0_716_824">
                <rect fill="white" height="28" transform="translate(0.201172 0.0568848)" width="22.612" />
            </clipPath>
        </defs>
    </svg>
);
export default FlutterIcon;
